"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ModalContentMobile = require("./ModalContentMobile");
Object.keys(_ModalContentMobile).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ModalContentMobile[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ModalContentMobile[key];
    }
  });
});